
    const _each = require("lodash/each");
    const _times = require("lodash/times");
    const _escape = require("lodash/escape");
    const _throttle = require("lodash/throttle");

    const _ = {
        each: _each,
        times: _times,
        escape: _escape,
        throttle: _throttle,
    };

    module.exports = function(context) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div is="instant-notification" class="instant-notification">';
 if (context.icon) { ;
__p +=
((__t = ( context.icon )) == null ? '' : __t);
 } ;
__p += '<p>' +
((__t = ( context.message )) == null ? '' : __t) +
'</p><div class="instant-notification__close glyph glyph-small glyph-cross-grey"></div></div>';
return __p
};
    